import React from "react";

interface ShareIconProps {
  style?: React.CSSProperties;
}

const ShareIcon: React.FC<ShareIconProps> = ({ style }) => {
  return (
    <svg
      width="24"
      height="24"
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 20.9714C16.8056 20.9714 16.2153 20.7093 15.7292 20.1852C15.2431 19.661 15 19.0245 15 18.2757C15 18.1859 15.0208 17.9762 15.0625 17.6467L9.20833 13.9626C8.98611 14.1872 8.72917 14.3633 8.4375 14.4909C8.14583 14.6185 7.83333 14.682 7.5 14.6814C6.80556 14.6814 6.21528 14.4193 5.72917 13.8952C5.24306 13.371 5 12.7345 5 11.9857C5 11.2369 5.24306 10.6004 5.72917 10.0762C6.21528 9.55208 6.80556 9.29 7.5 9.29C7.83333 9.29 8.14583 9.3538 8.4375 9.4814C8.72917 9.60899 8.98611 9.78481 9.20833 10.0089L15.0625 6.32471C15.0347 6.21988 15.0175 6.11894 15.0108 6.0219C15.0042 5.92485 15.0006 5.81612 15 5.69571C15 4.9469 15.2431 4.31042 15.7292 3.78625C16.2153 3.26208 16.8056 3 17.5 3C18.1944 3 18.7847 3.26208 19.2708 3.78625C19.7569 4.31042 20 4.9469 20 5.69571C20 6.44452 19.7569 7.08101 19.2708 7.60518C18.7847 8.12934 18.1944 8.39143 17.5 8.39143C17.1667 8.39143 16.8542 8.32763 16.5625 8.20003C16.2708 8.07244 16.0139 7.89661 15.7917 7.67257L9.9375 11.3567C9.96528 11.4615 9.98278 11.5628 9.99 11.6604C9.99722 11.7581 10.0006 11.8665 10 11.9857C9.99944 12.1049 9.99611 12.2137 9.99 12.3119C9.98389 12.4101 9.96639 12.5111 9.9375 12.6147L15.7917 16.2989C16.0139 16.0742 16.2708 15.8984 16.5625 15.7714C16.8542 15.6444 17.1667 15.5806 17.5 15.58C18.1944 15.58 18.7847 15.8421 19.2708 16.3662C19.7569 16.8904 20 17.5269 20 18.2757C20 19.0245 19.7569 19.661 19.2708 20.1852C18.7847 20.7093 18.1944 20.9714 17.5 20.9714Z"
        fill="black"
      />
    </svg>
  );
};

export default ShareIcon;
